export const SET_WORKFLOW_STATUS = 'WORKFLOW/SET_STATUS';
export const SET_WORKFLOW_EVALUATION = 'WORKFLOW/SET_EVALUATION';
